/**
 * @generated SignedSource<<0649d84e1331a6d6ec4b5ffbc03eadde>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ImageGenerationCreateInput = {
  categoriesForEdit: ReadonlyArray<number>;
  categoriesForGeneration: ReadonlyArray<number>;
  numberOfImagesEdit: number;
  numberOfImagesGeneration: number;
  serviceIDEdit?: number | null;
  serviceIDGeneration?: number | null;
};
export type aiImageGenEditor_CreateMutation$variables = {
  input: ImageGenerationCreateInput;
};
export type aiImageGenEditor_CreateMutation$data = {
  readonly createImageGeneration: {
    readonly id: string;
  };
};
export type aiImageGenEditor_CreateMutation = {
  response: aiImageGenEditor_CreateMutation$data;
  variables: aiImageGenEditor_CreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ImageGenerationDTO",
    "kind": "LinkedField",
    "name": "createImageGeneration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aiImageGenEditor_CreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "aiImageGenEditor_CreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c22bc57476ff60cf2b808cc3ab8051ff",
    "id": null,
    "metadata": {},
    "name": "aiImageGenEditor_CreateMutation",
    "operationKind": "mutation",
    "text": "mutation aiImageGenEditor_CreateMutation(\n  $input: ImageGenerationCreateInput!\n) {\n  createImageGeneration(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8ef2b07a81cd40b4e35eb85e20fce4c7";

export default node;
